module.exports = __webpack_public_path__ + "img/first-top.5bf9d85e.png";